/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voices_Event_Voice_Updated_ToastInputs */

const en_voices_event_voice_updated_toast = /** @type {(inputs: Voices_Event_Voice_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event voice updated successfully`)
};

const fr_voices_event_voice_updated_toast = /** @type {(inputs: Voices_Event_Voice_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voix de l'evenement mise a jour avec succes`)
};

const de_voices_event_voice_updated_toast = /** @type {(inputs: Voices_Event_Voice_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event-Sprache erfolgreich aktualisiert`)
};

const it_voices_event_voice_updated_toast = /** @type {(inputs: Voices_Event_Voice_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voce dell'evento aggiornata correttamente`)
};

const ru_voices_event_voice_updated_toast = /** @type {(inputs: Voices_Event_Voice_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Голосовое сообщение события успешно обновлено.`)
};

const es_voices_event_voice_updated_toast = /** @type {(inputs: Voices_Event_Voice_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La voz del evento se actualizó correctamente`)
};

const zh_cn2_voices_event_voice_updated_toast = /** @type {(inputs: Voices_Event_Voice_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件语音已成功更新`)
};

const ja_voices_event_voice_updated_toast = /** @type {(inputs: Voices_Event_Voice_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベント音声が正常に更新されました`)
};

const hi_voices_event_voice_updated_toast = /** @type {(inputs: Voices_Event_Voice_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट की आवाज़ सफलतापूर्वक अपडेट हो गई`)
};

const pt_pt2_voices_event_voice_updated_toast = /** @type {(inputs: Voices_Event_Voice_Updated_ToastInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Voz do evento atualizada com sucesso`)
};

/**
* | output |
* | --- |
* | "Event voice updated successfully" |
*
* @param {Voices_Event_Voice_Updated_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voices_event_voice_updated_toast = /** @type {((inputs?: Voices_Event_Voice_Updated_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voices_Event_Voice_Updated_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_voices_event_voice_updated_toast(inputs)
	if (locale === "de") return de_voices_event_voice_updated_toast(inputs)
	if (locale === "it") return it_voices_event_voice_updated_toast(inputs)
	if (locale === "ru") return ru_voices_event_voice_updated_toast(inputs)
	if (locale === "es") return es_voices_event_voice_updated_toast(inputs)
	if (locale === "zh-CN") return zh_cn2_voices_event_voice_updated_toast(inputs)
	if (locale === "ja") return ja_voices_event_voice_updated_toast(inputs)
	if (locale === "hi") return hi_voices_event_voice_updated_toast(inputs)
	if (locale === "pt-PT") return pt_pt2_voices_event_voice_updated_toast(inputs)
	return en_voices_event_voice_updated_toast(inputs)
});